import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import { ButtonUI, DialogUI } from '../Interface';
import { DocumentDirection } from '../../config/DocumentDirection';
import { formatCurrency } from '../../utils/currencyHelper';
import { formatDate } from '../../utils/dateHelper';
import SettlementForm from './SettlementForm';
import documentService from '../../service/newDoc.service';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';

const SettlementDialog = (props) => {
  const { documentData, open, onClose, setRefetchTable, selectedValuesState, calculateBalance, autocompleteData } =
    props;

  const { values, validateForm } = useFormikContext();

  const { setSelectedValues, selectedValues } = selectedValuesState;

  const issueDate = values?.issueDate ?? null;
  const docDate = values?.docDate ?? null;
  const dueDate = values?.dueDate ?? null;
  const sumInDocCur = values?.sumInDocCur ?? '';
  const outstanding = calculateBalance(values.settlement, values.sumInDocCur) ?? '';
  const currencyCode = values?.currencyCode ?? '';

  const selectedPaymentMethod = autocompleteData?.paymentMethod?.find((pm) => pm.id === values.paymentMethodId) ?? null;
  const defaultSettlementMode =
    autocompleteData?.settlementMode?.find((s) => s.code === selectedPaymentMethod?.defSettlementMode) ?? null;

  const label = documentData?.direction === DocumentDirection.INCOMING ? 'Kifizetések' : 'Befizetések';
  return (
    <DialogUI open={open} onClose={onClose} headerContent={label} maxWidth="md" fullWidth>
      <Grid container spacing={1} mt={1} sx={{ background: '#E9F5FE', borderRadius: '4px', p: '0.5rem' }}>
        {/* Left column: Dates */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={0.5} alignItems="center">
            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">
                Kiállítás dátuma
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{formatDate(issueDate)}</Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">
                Teljesítés dátuma
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{formatDate(docDate)}</Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">
                Határidő
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{formatDate(dueDate)}</Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid container spacing={0.5} alignItems="center">
            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">
                Bruttó
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">
                {formatCurrency(sumInDocCur)}
                {currencyCode ? ` ${currencyCode}` : ''}
              </Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">
                Kintlévőség
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">
                {formatCurrency(outstanding)}
                {currencyCode ? ` ${currencyCode}` : ''}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <SettlementForm {...props} defaultSettlementMode={defaultSettlementMode} />

      <Box display="flex" justifyContent="right" gap="0.5rem" mt="1rem">
        <ButtonUI
          text="Rögzítés"
          className="bg-success"
          onClick={async () => {
            const errors = await validateForm();
            if (errors.settlement) {
              return;
            }

            const settlements = values.settlement.map((s) => ({
              ...s,
              id: s.isNew ? null : s.id,
              isNew: undefined,
            }));

            documentService
              .upsertSettlement({ settlements, baseId: selectedValues.docId, baseType: documentData?.documentTypeId })
              .then(() => documentService.getDocumentById(selectedValues.docId, documentData?.documentTypeId))
              .then((data) => {
                addNotification({
                  content: 'Sikeres mentés!',
                  type: NotificationType.SUCCESS,
                });

                setRefetchTable(true);

                setSelectedValues(data);
                onClose();
              });
          }}
        />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default SettlementDialog;
